export const ItemSelected = 'ItemSelected';
export const InteractionStarted = 'InteractionStarted';
export const PointerIntersection = 'PointerIntersection';
export const VisualizationUpdated = 'VisualizationUpdated';
